import request from '../../../helpers/request';

const createCounterparty = async (formValues) => {
  const response = await request.post(
    '/RentPlace/counterparty',
    {
      ...formValues,
    },
    'При создании контрагента произошла ошибка'
  );
  return response?.id;
};
export default createCounterparty;
